<template>
  <nav class="menu-shop">
    <a v-if="isGuest" :href="customerEditURL" class="link customer-data-link"><span class="icon-profile icon"></span> <span class="text">{{ translate('Kundendaten') }}</span></a>
    <div v-if="isLoggedIn" class="has-submenu">
      <a href="#" v-on:click.prevent="showMobileMenu = !showMobileMenu" class="link main my-theater-link"><span class="icon-profile-logged icon"></span> <span class="customerName">{{customerName}}</span> <span class="customerNameShort">{{customerName}}</span></a>
        <div v-bind:class="{ 'is-active': showMobileMenu }" class="submenu">
          <a :href="selfcareURL" class="link my-theater-link" :class="{ 'is-active': isLinkActive(selfcareURL) }"><span class="text">{{ translate('Meine Oper Leipzig') }}</span></a>
          <a :href="marketURL" class="link my-theater-link" :class="{ 'is-active': isLinkActive(marketURL) }"><span class="text">{{ translate('Ticketbörse') }}</span></a>
          <a :href="myOrdersURL" class="link my-theater-link" :class="{ 'is-active': isLinkActive(myOrdersURL) }"><span class="text">{{ translate('Meine Bestellungen') }}</span></a>
          <a :href="profileEditURL" class="link my-theater-link" :class="{ 'is-active': isLinkActive(profileEditURL) }"><span class="text">{{ translate('Mein Profil') }}</span></a>
          <a :href="passwordChangeURL" class="link my-theater-link" :class="{ 'is-active': isLinkActive(passwordChangeURL) }"><span class="text">{{ translate('Passwort ändern') }}</span></a>
          <a v-on:click="clearCookies" :href="logoutURL" class="link logout-link" :class="{ 'is-active': isLinkActive(logoutURL) }"><span class="text">{{ translate('Abmelden') }}</span></a>
        </div>
    </div>
    <a v-if="!isLoggedIn" :href="loginURL" class="link login-link"><span class="icon-user icon"></span> <span class="text">{{ translate('Anmelden') }}</span></a>
    <a v-if="!!favoritesURL" :href="favoritesURL" class="link favorite-link">
      <count-items />
        <span class="text">{{ translate('Merkliste') }}</span>
    </a>
    <a :href="cartURL" class="link cart-link"> <span class="icon-cart icon"><span v-if="hasCartItems" class="badge">{{cartAmount}}</span></span> <span class="text">{{ translate('Warenkorb') }}</span> </a>
  </nav>
</template>

<script>
    import CountItems from '@/components/CountItems'
    import translationMixin from '@/mixins/translation'
    export default {
      name: 'Favorite',
      components: {
        CountItems
      },
      props: {
        customerNameShort: null,
      },
      mixins: [translationMixin],
      data () {
        return {
         showMobileMenu: false,
        }
      },
      computed: {
        customerName: function () {
          return this.$store.getters.customerName
        },
        language: function () {
          return document.querySelector("html").getAttribute('lang')
        },
        isLoggedIn: function () {
          return this.$store.getters.isLoggedIn()
        },
        isGuest: function () {
          return this.$store.getters.isGuest
        },
        cartAmount: function () {
          return this.$store.state.navigation.cartAmount
        },
        hasCartItems: function () {
          return this.$store.getters.hasCartItems
        },
        customerEditURL: function () {
          return window.DjangoApp.settings.CUSTOMER_EDIT_DETAILS_URL
        },
        selfcareURL: function () {
          return window.DjangoApp.settings.MY_THEATER_URL
        },
        marketURL: function () {
          return window.DjangoApp.settings.MARKET_URL
        },
        myOrdersURL: function () {
          return window.DjangoApp.settings.MY_ORDERS_URL
        },
        profileEditURL: function () {
          return window.DjangoApp.settings.PROFILE_EDIT_URL
        },
        passwordChangeURL: function () {
          return window.DjangoApp.settings.PASSWORD_CHANGE_URL
        },
        loginURL: function () {
          return window.DjangoApp.settings.LOGIN_URL
        },
        logoutURL: function () {
          return window.DjangoApp.settings.LOGOUT_URL
        },

        favoritesURL: function () {
          return window.DjangoApp.settings.FAVORITES_URL
        },
        cartURL: function () {
          return window.DjangoApp.settings.CART_URL + '?language=' + this.language
        },
      },
      methods: {
        checkIfIsLoggedIn: function() {
          this.$store.dispatch('loadCustomer')
        },
        clearCookies: function (){
          this.$store.dispatch('deleteCustomCookies')
        },
        isLinkActive(url) {
          return window.location.pathname === url
        }
      },
      beforeMount(){
        this.$store.dispatch('saveGuestStatus')
        this.$store.dispatch('saveCartToCookie')
        this.checkIfIsLoggedIn()
     },
    }
</script>
